var VideoInfoModalModule = /** @class */ (function () {
    function VideoInfoModalModule() {
    }
    return VideoInfoModalModule;
}());
export { VideoInfoModalModule };
